import Chartjs from 'chart.js';
import { rgba } from 'polished';
import * as React from 'react';
import { DailyCase } from '../../api/mathdroid';

export interface DailyCasesChartProps {
  data: DailyCase[];
}

export const DailyCasesChart: React.FC<DailyCasesChartProps> = ({ data }) => {
  const chartCanvas = React.useRef<HTMLCanvasElement | null>(null);

  React.useEffect(() => {
    if (!chartCanvas?.current) {
      return;
    }

    const labels: string[] = [];

    const confirmedDataset: Chartjs.ChartDataSets = {
      label: 'Confirmed',
      data: [],
      backgroundColor: rgba('#1E1C1D', 0.2),
      borderColor: '#1E1C1D',
    };

    const deathsDataset: Chartjs.ChartDataSets = {
      label: 'Deaths',
      data: [],
      backgroundColor: rgba('#DA2C38', 0.2),
      borderColor: '#DA2C38',
    };

    data.forEach(({ reportDate, confirmed, deaths }) => {
      labels.push(reportDate);
      confirmedDataset.data!.push(confirmed.total);
      deathsDataset.data!.push(deaths.total);
    });

    // eslint-disable-next-line no-new
    new Chartjs(chartCanvas.current, {
      type: 'line',
      data: { labels, datasets: [confirmedDataset, deathsDataset] },
      options: {
        legend: { position: 'bottom' },
        scales: { yAxes: [{ ticks: { beginAtZero: true } }] },
        tooltips: { mode: 'index' },
      },
    });
  }, [data]);

  return <canvas ref={chartCanvas} />;
};
